import './CreateSkillModal.css';
import React from 'react';
import { Modal, FormGroup, ControlLabel, FormControl, Button, Form, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { SkillTypes } from '../../constants/skillTypes';

export const CreateSkillModal = ({show, hide, data, updated, submitted, showCreateSkillGroupModal}) => {
    return (
        <Modal show={show} onHide={hide}>
            <Modal.Header closeButton>
                <Modal.Title>Add New Skill</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form horizontal onSubmit={submitted}>

                    {formTextField('Skill Name', 'Phonemeic Awareness, e.g., MySkillName', updated, data.skillNameValidation)}
                    {formOptionsField('Skill Group', data.skillGroups, updated, data.skillGroupValidation)}
                    <a id="newSkillGroup" onClick={() => showCreateSkillGroupModal()}>+Skill Group</a>
                    {formOptionsField('Skill Type', SkillTypes, updated, data.skillTypeValidation)}
                    {renderButton(data.isRequesting, data.isFormValid)}

                </Form>
            </Modal.Body>
        </Modal>
    );
};

const renderButton = (isRequesting, isFormValid) =>
{
    if(isRequesting)
    {
        return( 
            <Button type="submit" style={{backgroundColor:'blue', color: 'white'}} block disabled={isRequesting}>Creating...</Button>
        );
    }
    else
    {
        return(
            <Button type="submit" bsStyle="success" block disabled={isFormValid && !isRequesting}>Create</Button>            
        )
    }
}

const formTextField = (label, placeholder, onChange, validation) => {
    return (
        <FormGroup controlId={`formHorizontal${label}`} validationState={validation}>
            <Col componentClass={ControlLabel} sm={3}>{label}</Col>
            <Col sm={9}>
                <FormControl type='text' name={label} placeholder={placeholder} onChange={onChange} />
                <FormControl.Feedback />
            </Col>
        </FormGroup>
    );
};

const formOptionsField = (label,  options, onChange, validation) => {
    return (
        <FormGroup controlId={`formHorizontal${label}`} validationState={validation}>
            <Col componentClass={ControlLabel} sm={3}>{label}</Col>
            <Col sm={9}>
                <FormControl componentClass='select' name={label} onChange={onChange} defaultValue=''>
                    <option value='' disabled/>
                    {Object.entries(options).map(formOption)}
                </FormControl>
                <FormControl.Feedback />
            </Col>
        </FormGroup>
    );
};

const formOption = kvp => {
    return (<option key={kvp[0]} value={kvp[1]}>{kvp[1]}</option>);
};


CreateSkillModal.propTypes = {
    show:       PropTypes.bool.isRequired,
    hide:       PropTypes.func.isRequired,
    data:       PropTypes.object.isRequired,
    updated:    PropTypes.func.isRequired,
    submitted:  PropTypes.func.isRequired,
    showCreateSkillGroupModal: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/createSkillModal/CreateSkillModal.js